import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMrtVerifiedVisitsAPI } from '../../../services/mrt-service';

import {
    FETCH_VERIFIED,
    FETCH_VERIFIED_START,
    FETCH_VERIFIED_SUCCESS,
    FETCH_VERIFIED_ERROR,
    SET_MRT_VERIFIED_FILTER,
    SET_VERIFIED_PAGINATION


} from "../../actions/mrt/verifiedAction";

function* fetchVerificationVisits({ payload }) {
    try {
        yield put({ type: FETCH_VERIFIED_START })
        const response = yield call(getMrtVerifiedVisitsAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_VERIFIED_SUCCESS, verified: response.data.mrtVerified });
            yield put({ type: SET_MRT_VERIFIED_FILTER, payload: { ...payload } });
            yield put({ type: SET_VERIFIED_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_VERIFIED_ERROR, error: response.error })
            message.error('Failed to fetch verified reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_VERIFIED_ERROR, error })
        message.error('Failed to fetch verified reports!');
    }
}



function* verifiedWatcher() {
    yield takeEvery(FETCH_VERIFIED, fetchVerificationVisits)
}

export default function* rootSaga() {
    yield all([
        verifiedWatcher(),
    ]);
}